export const useExpandAccordion = () => {
  const { $bootstrap } = useNuxtApp()

  const expandAccordionIfNeeded = (id: string) => {
    let collapseEl = document.getElementById(`d-${id}`)

    if (!collapseEl) {
      collapseEl = document.querySelector<HTMLElement>(`[data-kontent-id="d-${id}"]`)
    }

    if (collapseEl && $bootstrap?.Collapse) {
      const collapseInstance = $bootstrap.Collapse.getOrCreateInstance(collapseEl, {
        toggle: false,
      })
      collapseInstance.show()
    }
  }

  return { expandAccordionIfNeeded }
}